import { cacheService } from 'ci-common-ui';
import { XHR_REQUESTS_KEY } from '../constants/browser-storage';

const DataCacheService = new cacheService({ storageKey: XHR_REQUESTS_KEY });

export default DataCacheService;
